import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Currency, MultipleCarsPerUserTreatAs, ParkingSubscriptionType, ParkingSubscriptionUsage, ParkingSubscriptionPaidBy as ParkingSubscriptionPaidBy, IParkerCompanyDTO } from 'src/app/base/models/models.swagger.generated';
import { CurrencyCents } from './currency-cents';
import { TranslateModule } from '@ngx-translate/core';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgClass } from '@angular/common';
import { MultiFieldDurationPickerComponent } from '../../../../../../base/shared/multi-field-duration-picker/multi-field-duration-picker.component';
import { ButtonGroupComponent } from '../../../../../../base/shared/button-group/button-group.component';
import { YesNoGroupButtonComponent } from '../../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AppErrorMessagesComponent } from '../../../../../../base/error-messages/app-error-messages.component';
import { SubscriptionEditFormGroup } from './subscription-details-general-form.type';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { CompanyService } from 'src/app/base/services/company.service';
import { DropDownConstantsFactory } from '../../../../../../base/shared/syncfusion/dropdown-constants-factory';
import { Observable, of, Subscription } from 'rxjs';
import { DataManager } from '@syncfusion/ej2-data';
import { SimpleGetCustomAdaptor } from 'src/app/base/shared/syncfusion/simple-get-custom-adaptor';

export type MaxParkingDurationInMinFormType = {
  days: FormControl<number>;
  hours: FormControl<number>;
  minutes: FormControl<number>;
};

@Component({
    selector: 'app-subscription-details-general',
    templateUrl: './subscription-details-general.component.html',
    styleUrls: ['./subscription-details-general.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, ButtonGroupComponent, MultiFieldDurationPickerComponent, NgClass, NumericTextBoxModule, TranslateModule, DropDownListModule],
    providers: [CompanyService],
})
export class SubscriptionDetailsGeneralComponent implements OnInit, OnDestroy {
  @Input() subscriptionForm: SubscriptionEditFormGroup;

  public CurrencyEnum = Currency;
  public CurrencyCentsEnum = CurrencyCents;
  public ParkingSubscriptionType = ParkingSubscriptionType;
  public MultipleCarsPerUserTreatAs = MultipleCarsPerUserTreatAs;
  public Usage = ParkingSubscriptionUsage;
  public PaidBy = ParkingSubscriptionPaidBy;

  public data: DataManager;

  private subscription: Subscription = new Subscription();

  public getCompanies(): Observable<IParkerCompanyDTO[]> {
    if (this.subscriptionForm.controls.clientId.getRawValue() != null) {
      return this.companyService.getCompanies(this.subscriptionForm.controls.clientId.getRawValue());
    }
    return of([]);
  }

  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();

  constructor(private companyService: CompanyService) {
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new SimpleGetCustomAdaptor<IParkerCompanyDTO>(this.getCompanies.bind(this)),
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
